<template>
  <div class="toast-container position-fixed bottom-0 end-0 p-3" style="z-index: 9999">
    <div
      v-for="toast in toasts"
      :key="toast.id"
      class="toast show align-items-center border-0 mb-2"
      :class="`text-bg-${toast.type}`"
      role="alert"
      aria-live="assertive"
      aria-atomic="true"
    >
      <div class="d-flex">
        <div class="toast-body">
          {{ toast.message }}
        </div>
        <button
          type="button"
          class="btn-close btn-close-white me-2 m-auto"
          @click="removeToast(toast.id)"
          aria-label="Close"
        ></button>
      </div>
    </div>
  </div>
</template>

<script>
import { useToastStore } from '@/stores/toastStore';
import { computed } from 'vue';

export default {
  name: 'ToastContainer',
  setup() {
    const toastStore = useToastStore();
    const toasts = computed(() => toastStore.toasts);

    const removeToast = (id) => {
      toastStore.removeToast(id);
    };

    return {
      toasts,
      removeToast
    };
  }
};
</script>

<style scoped>
.toast-container {
  max-width: 350px;
}
</style>
